import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getOrderCacheDetailLista = async () => {
    const res = await getData('/ordercachedetail/ordercachedetail_select');
    return res
}

export const getOrderCacheDetailPanel = async (searchOca, searchArt, page, perPage) => {
    let queryParams = [];
    if (searchOca) {
        queryParams.push(`oca_id=${encodeURIComponent(searchOca)}`);
    }
    if (searchArt) {
        queryParams.push(`art_Id=${encodeURIComponent(searchArt)}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    const res = await getData(`/ordercachedetail/getOrderCacheDetailOca_Id${queryString}`);
    return res;
};

export const getOrderCacheDetailById = async (id) => {
    const res = await getData(`/ordercachedetail/${id}`)
    return res
}

export const postOrderCacheDetail = async (body) => {
    const res = await postData('/ordercachedetail', body)
    return res
}

export const patchOrderCacheDetail = async (id, body) => {
    const res = await patchData(`/ordercachedetail/${id}`, body)
    return res
}

export const deleteOrderCacheDetail = async (id) => {
    const res = await deleteData(`/ordercachedetail/${id}`)
    return res
}
